export default "__VITE_ASSET__DzqrrOfg__"